import React from 'react';
import { Link } from 'react-router';
import { profilesRoute } from '../routes/index';
import pluralize from 'pluralize';

export default function formatCredits(profiles = [], showPoint = true, linkProfiles = true) {
	let credits = [];
	let className = 'case-credit__name';
	let split = ' and ';

	if (!showPoint) {
		className += ' case-credit__name--faded';
	}

	if (profiles.length > 2) {
		split = ', ';
	}

	for (var i = 0; i < profiles.length; i++) {
		if (credits.length) {
			credits.push(<span key={i + 's'}>{split}</span>);
		}

		if (profiles[i].name) {
			let LinkComp = Link;
			const newProps = {
				key: i,
				className: className,
			};

			if (linkProfiles && !profiles[i].isPoor && (profiles[i].total || (!profiles[i].total && profiles[i].website))) {
				if (profiles[i].total) {
					newProps.to = profilesRoute(profiles[i].slug);
				} else {
					LinkComp = 'a';
					newProps.href = profiles[i].website;
					newProps.target = '_blank';
				}
			} else {
				LinkComp = 'span';
				newProps.className += ' case-credit__name--nolink';
			}

			credits.push(
				React.createElement(
					LinkComp,
					newProps,
					[
						profiles[i].name,
						(showPoint && (
							<span className='case-credit__count' key='count'> {profiles[i].total ?
									`(${profiles[i].total} ${pluralize('FWAs', profiles[i].total)})` : ''
							}</span>
						)),
					]
				)
			);
		}
	}

	return <span className='case-credit'>{credits}</span>;
};



/** WEBPACK FOOTER **
 ** ./frontend/utils/formatCredits.js
 **/